import React, { useEffect, useState } from 'react';
import { Link, Navigate } from 'react-router-dom';
import axios from "axios";
import Page from 'components/Page';
import AppHeader from 'components/AppHeader';

import './styles.scss';

export default function LeaderBord() {
    const [pseudo, setPseudo] = useState('');
    const [userScore, setUserScore] = useState(null);
    const [scorePosted, setScorePosted] = useState(false);
    const [disabled, setDisabled] = useState(false);

    const handleOnChange = (event) => {
        setPseudo(event.target.value);
    };

    const handleFormSubmit = function (event) {
        event.preventDefault();
        setDisabled(!disabled);
        if (pseudo.length < 2 || pseudo.length > 15) {
            setDisabled(false);
            window.alert("Pseudo non valide")
            return
        }
        const options = {
            method: 'POST',
            url: `${process.env.REACT_APP_API_URL}/score`,
            headers: { 'Content-Type': 'application/json' },
            data: { pseudo: pseudo }
        };
        axios.defaults.withCredentials = true;
        axios.request(options).then(function (response) {
            if (response.status === 200) {
                setScorePosted(true);
            } else {
                window.alert("Je pense qu'il y a eu un petit souci, essais encore")
            }
        })
            .catch(function (error) {
                console.error(error);
            });
    }


    useEffect(() => {
        const options = { method: 'GET', url: `${process.env.REACT_APP_API_URL}/score` };
        axios.defaults.withCredentials = true;
        axios.request(options).then(function (response) {
            setUserScore(response.data.userScore);
        }).catch(function (error) {
            console.error(error);
        });

        return () => { }
    }, []);

    return (
        <>
            <AppHeader />
            <Page>
                <div className="content">
                    <div className="newScore">
                        <div className="leaderBord">Votre score est de : {userScore}</div>
                        <form action="#" onSubmit={handleFormSubmit}>
                            <label htmlFor="pseudo">Pour ajouter votre score au tableau des scores, entrez votre pseudo</label>
                            <input type="text"
                                name="pseudo"
                                id="pseudo"
                                minLength="2"
                                maxLength="20"
                                autoFocus
                                value={pseudo}
                                onChange={handleOnChange} />
                                
                            {disabled ? (
                                <input
                                className='button button_help a'
                                disabled
                                type="submit"
                                value="Valider" />
                            ) : (
                                <input
                                className='button button_help b'
                                type="submit"
                                value="Valider" />
                            )}
                        </form>
                    </div>
                    <Link to={'/quiz'}>
                        <div className="button" >Rejouer ?</div>
                    </Link>
                </div>
            </Page>
            {scorePosted && (
                <Navigate to="/scores" replace={true} />
            )}
        </>
    );
}